import * as Long from "long";
import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectBalancingSkipConstructionFactor } from "../../../../balancingSelectors/selectBalancingConstants";
import { IdResource } from "../../../../constants/IdResource";
import { selectBuildingConstructionInProgress } from "../../../../selectors/selectBuildingConstructionInProgress";
import { BuildingStateType, CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { utilSkipProcess } from "../../../../utils/utilSkipProcess";
import { utilTime } from "../../../../utils/utilTime";
import { actionInventoryInfoRemoveResource } from "../../../info/inventory/actionInventoryInfo";
import { actionModalClose } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionOngoingPurchasePremiumDeselect, actionOngoingPurchaseStandardDeselect, } from "../../../ongoing-purchase/actionOngoingPurchase";
import { actionBuildingsSelect, actionBuildingsSelectBeforePlacement, actionBuildingsStartUpgrade, TypeActionBuildings, } from "../actionBuildings";
import { TypeBuildingAction } from "../reducerBuildings";
export var epicBuildingsSkipConstructionConfirmed = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuildings.SkipConstructionConfirmed), switchMap(function (action) {
        var state = state$.value;
        var building = action.building;
        var buildingToSkipConstruction = building;
        if (action.action === TypeBuildingAction.Construct) {
            buildingToSkipConstruction = selectBuildingConstructionInProgress(state);
        }
        var isUpgrade = buildingToSkipConstruction.proto.state === BuildingStateType.UPGRADING;
        var remainingTime = utilTime.secondsLeftTill(buildingToSkipConstruction.proto.remainingTime);
        var factor = selectBalancingSkipConstructionFactor();
        // TODO: {long} check if cast is valid
        var GoldCost = Long.fromInt(utilSkipProcess.calculateCostToSkipProcess(remainingTime, factor));
        return deps
            .netSend({
            id: isUpgrade ? CommandCode.SkipUpgrade : CommandCode.SkipConstruct,
            props: {
                amount: GoldCost,
                buildingId: buildingToSkipConstruction.proto.id,
                farmId: state.playerBase.base.baseId,
                itemId: IdResource.Gold,
                playerId: state.playerInfo.playerId,
            },
        })
            .pipe(retry(), switchMap(function (res) {
            // To be able to use actionBuildingsSelect
            buildingToSkipConstruction.proto.remainingTime = undefined;
            var actions = [];
            var sourceAction = state.playerBase.buildings.action;
            actions.push(actionModalClose(IdModal.SkipProcess), actionOngoingPurchaseStandardDeselect(), actionOngoingPurchasePremiumDeselect(), actionInventoryInfoRemoveResource([
                { typeId: res.itemId, amount: res.amount },
            ]));
            if (action.action === TypeBuildingAction.Construct &&
                sourceAction === TypeBuildingAction.Upgrade) {
                actions.push(actionModalClose(IdModal.BuildingUpgrade));
            }
            if (action.action === TypeBuildingAction.Construct &&
                sourceAction === TypeBuildingAction.Upgrade) {
                actions.push(actionBuildingsSelect(action.building));
                actions.push(actionBuildingsStartUpgrade(action.building));
            }
            else {
                actions.push(actionBuildingsSelectBeforePlacement(action.building));
            }
            return from(actions);
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsSkipConstructionConfirmed.ts
// module id = 2085
// module chunks = 3